::slotted([slot=title]) {
  margin: 0 0 20px !important;
  flex: 1 1 auto;
}

.cards-wrapper {
  box-sizing: border-box;
  margin: auto;
}

.cards-wrapper *,
.cards-wrapper *::before,
.cards-wrapper *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .cards-wrapper__header {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
}

@media screen and (max-width: 979px) {
  .switch-view {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  .switch-view {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    margin-bottom: 20px;
  }
}

:host(:not([dir="rtl"])) slot[name=title] + .switch-view {
  margin-left: 20px;
}

:host([dir="rtl"]) slot[name=title] + .switch-view {
  margin-right: 20px;
}

.cards-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cards-item:not(:last-child) {
  margin-bottom: 20px;
}

@media screen and (max-width: 719px) {
  .cards-item:not(:last-child) {
    margin-bottom: 20px;
  }
}

.product_card {
  height: 100%;
}

@media screen and (min-width: 980px) {
  .cards-wrapper {
    max-width: 100%;
    margin: auto;
  }

  .cards-wrapper.grid-view .cards-list {
    display: flex;
    flex-wrap: wrap;
    max-width: 880px;
    margin-left: auto;
    margin-right: auto;
  }

  .cards-wrapper.grid-view .cards-item {
    min-height: 100%;
    width: 33.3%;
    min-width: 292px;
  }

  .cards-wrapper.grid-view .cards-item:not(:last-child) {
    margin-bottom: 0px;
  }

  .cards-wrapper.list-view .cards-list {
    border-top: 1px solid transparent;
    max-width: 880px;
    margin-left: auto;
    margin-right: auto;
  }

  .cards-wrapper.list-view .cards-item {
    margin: 0;
  }
}

@media only screen and (max-height: 430px) {
  .cards-item {
    width: 400px;
    margin: 0 auto;
  }
}